export const domainsToSeePriceChangeWarning = [
  // Companies de teste para validar que o modal aparece no pós deploy
  "dev.conectanuvem.com.br",
  "conectanuvem.onmicrosoft.com",

  // Companies de teste para validar que o modal não aparece no pós deploy
  // "conectaplanning.com.br",
  // "delicakes.com.br",
  // "eductech.com.br",
  // "gourmetizeti.xyz",

  "addebitare.com.br",
  "advogardigital.com",
  "agenciacosmica.com.br",
  "agnaldobastos.adv.br",
  "aliar.org.br",
  "allog.com.br",
  "allpartsnet.com.br",
  "amtassessoria.com.br",
  "araujomontagem.com.br",
  "atitudeinovacao.com.br",
  "atl.com.br",
  "barbosatranm.com.br",
  "barucseguros.com.br",
  "bomcontrole.com.br",
  "bregaldacorretora.com.br",
  "broslogistica.com.br",
  "caporaliseguros.com.br",
  "cavan.com.br",
  "conexled.com.br",
  "confettiagencia.com.br",
  "construtorack.com.br",
  "coppergroup.com.br",
  "corpvs.com.br",
  "crisciuma.com.br",
  "cursinoadvogados.adv.br",
  "dcampos.com.br",
  "digitalfavela.com.br",
  "dlsa.com.br",
  "ebmac.com.br",
  "ecomedicalcenter.com.br",
  "eduardoadvocacia.com",
  "efizi.com.br",
  "envisione.com.br",
  "esm.adv.br",
  "estilojg.com.br",
  "focomedicina.com",
  "focosmais.com.br",
  "foursales-company.com",
  "galpaocentrooeste.com.br",
  "gearseo.com.br",
  "gestaoservicosaude.com.br",
  "gimi.com.br",
  "gmsegurosebeneficios.com.br",
  "gruc.com.br",
  "gruen.com.br",
  "grupolumis.com.br",
  "grupopointdoacai.com.br",
  "grupovaliant.com.br",
  "grupovono.com.br",
  "haacke.com.br",
  "hartmann.com.br",
  "hengelequipamentos.com.br",
  "hippusaldeia.com.br",
  "hotelsibara.com.br",
  "hsantos.com.br",
  "icc-ocd.com.br",
  "ideauto.com.br",
  "incentivarconsultoria.onmicrosoft.com",
  "inlov.com.br",
  "latika.com.br",
  "lbdeng.page",
  "lbin.com.br",
  "leandrofialhoadvogados.com.br",
  "link2home.com.br",
  "locusmed.com.br",
  "ludvig.com.br",
  "lvalenca.com.br",
  "mardoce.me",
  "metalurgicaathual.com.br",
  "milvus.com.br",
  "mjpcontroller.com.br",
  "morecotech.com",
  "mowbrazil.com",
  "msantosip.com",
  "mschmidtcontabil.com.br",
  "multipine.com",
  "multivac.com.br",
  "newspace.com.br",
  "nexcont.com.br",
  "nexti.com",
  "osselcomercial.com",
  "oto.com.br",
  "pandoratreinamentos.com.br",
  "perfiladospipe.com.br",
  "pipest.com.br",
  "procave.com.br",
  "protecprotecoes.com.br",
  "protestopb.com.br",
  "qprime.pt",
  "qualyservice.ind.br",
  "r8live.com.br",
  "rachadelgroup.com.br",
  "rcamposcorretora.com.br",
  "rennosonic.com",
  "revellatest.com",
  "rranacorretagem.onmicrosoft.com",
  "rybena.com.br",
  "ryme.lt",
  "sangiogoadvogados.com.br",
  "sdamed.com",
  "sdvadvogados.com.br",
  "sejaumpartner.com",
  "sementesbarreirao.com.br",
  "senar-ro.org.br",
  "siembra.com.br",
  "simgular.com.br",
  "simplanodesaude.com.br",
  "sintrabor.org.br",
  "softconsc.com.br",
  "solucoesgnn.com.br",
  "sow.inf.br",
  "sstocupacional.com.br",
  "superfix.ind.br",
  "sustentec.com.br",
  "targetlaw.com.br",
  "totalgarantidora.com.br",
  "tothetop.app.br",
  "totoy.tech",
  "unityagro.com.br",
  "yangzi.com.br",
  "yesh.com.br",
];
